// home.js


import React from "react";
import { HashLink as Link } from 'react-router-hash-link';
import { Col, Container, Row } from "reactstrap";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "./scss/home.scss";
import ButtonAesthetic from '../../../assets/scss/components/buttonaesthetic';

const Home = () => {
  return (
    <React.Fragment>
      <section
        id="home"
        className="hero-section"
      >
        <Container className="pt-5">
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <h1 className="display-4 fw-bold mb-4 text-shadow">
                Automatiza tus procesos con
                <span style={{ color: "#E0DEFF" }}> BackApp Chile</span>
              </h1>
              <p className="lead text-light mb-5" style={{ opacity: 0.85 }}>
                Administración, Contabilidad y Recursos Humanos en un solo lugar.<br />
                Futurista, simple y hecho para PYMEs chilenas.
              </p>
              <div className="d-flex justify-content-center gap-3 flex-wrap">
                <ButtonAesthetic text="Tax Review Gratis" href="#contact" />
                <ButtonAesthetic text="Ver Servicios" href="#services" outline />
              </div>
            </Col>
          </Row>
        </Container>

        {/* SVG decorativo Clay */}
        <div className="svg-container">
          <svg
            className="hero-svg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff22"
              d="M0,0 C360,100 1080,20 1440,100 L1440,120 L0,120 Z"
            />
          </svg>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Home;
